// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__88_gC","question":"styles_question__2DCj5","description":"styles_description__39RTj"};